import { createContext } from 'react';

export const TagsContext = createContext<{
  tags: string[];
}>(null);

export const TagsProvider = ({ children, tags }) => {
  return <TagsContext.Provider value={{ tags }}>{children}</TagsContext.Provider>;
};
